import baseUrl from '../../config'; // 这里设置了一个文件作为所有请求的基础ip地址
function playersType(text) {
    switch (text) {
        case 'defender':
            return '后卫';
        case  'midfielder':
            return '中场';
        case  'forward':
            return '前锋';
        case  'goalkeeper':
            return '门将';
    }
}
//传年月日 算周岁
function byage(strBirthday) {
    var returnAge;
    var strBirthdayArr = strBirthday.split("/");
    var birthYear = strBirthdayArr[0];
    var birthMonth = strBirthdayArr[1];
    var birthDay = strBirthdayArr[2],
        d = new Date();
    var nowYear = d.getFullYear();
    var nowMonth = d.getMonth() + 1;
    var nowDay = d.getDate();
    if (nowYear == birthYear) {
        returnAge = 0;//同年 则为0岁
    } else {
        var ageDiff = nowYear - birthYear; //年之差
        if (ageDiff > 0) {
            if (nowMonth == birthMonth) {
                var dayDiff = nowDay - birthDay;//日之差
                if (dayDiff < 0) {
                    returnAge = ageDiff - 1;
                } else {
                    returnAge = ageDiff;
                }

            } else {
                var monthDiff = nowMonth - birthMonth;//月之差
                if (monthDiff < 0) {
                    returnAge = ageDiff - 1;
                } else {
                    returnAge = ageDiff;
                }
            }
        } else {
            returnAge = -1;//返回-1 表示出生日期输入错误 晚于今天
        }
    }
    return returnAge;//返回周岁年龄
}


//url参数
function GetQueryString(name,urlMsg) {
    var url = urlMsg?urlMsg:document.location.toString();
    var arrObj = url.split("?");

    if (arrObj.length > 1) {
        var arrPara = arrObj[1].split("&");
        var arr;

        for (var i = 0; i < arrPara.length; i++) {
            arr = arrPara[i].split("=");

            if (arr != null && arr[0] == name) {
                return arr[1];
            }
        }
        return "";
    }
    else {
        return "";
    }
}

//随机数
function randomFn(arr,arr2) {
    let arrLen=arr.length;
    let arr2Len,str;
    if(arr2&&arr2.length){
        arr2Len=arr2.length;
        str=arr[Math.floor(Math.random()*arrLen)]+ arr2[Math.floor(Math.random()*arr2Len)]
    }else {
        str=arr[Math.floor(Math.random()*arrLen)]
    }
    return str
}

//汉字长度
function strLength(s) {

    var reg = /[\u4e00-\u9fa5]/g;
    return s.match(reg).length
}
function copy(obj) {
    return JSON.parse(JSON.stringify(obj))
}
//Ai语音播放
function audioPlayUrl(str){
    return baseUrl.DOMAIN_NAME.AI_URL_TTS+'/tts?text='+str;
    // return baseUrl.TEST_CNODEJS+'/tts?text='+str;
}
//数组中任意多个值
function getRandomArrayElements(arr, count) {
    var shuffled = arr.slice(0), i = arr.length, min = i - count, temp, index;
    while (i-- > min) {
        index = Math.floor((i + 1) * Math.random());
        temp = shuffled[index];
        shuffled[index] = shuffled[i];
        shuffled[i] = temp;
    }
    return shuffled.slice(min);
}
//日期格式化
function formatDate(time, type, format) {
    /**
     * time 时间
     * type 类型（默认'yyyy-MM-dd HH:mm'）
     */
    if (!time) return time;
    var date = "";
    if (format) {
        date = time;
    } else {
        if (typeof time !== "number") {
            time = time.replace(/-/g, "/");
        }
        date = new Date(time);
    }
    type = type ? type : "yyyy-MM-dd HH:mm";
    var seperator1 = "-";
    var seperator2 = ":";
    var seperator3 = "/";
    var month = (date.getMonth() + 1).toString();
    var day = date.getDate().toString();
    var hours = date.getHours().toString();
    var minutes = date.getMinutes().toString();
    var seconds = date.getSeconds().toString();
    month = month.length === 1 ? ("0" + month) : month;
    day = day.length === 1 ? ("0" + day) : day;
    hours = hours.length === 1 ? ("0" + hours) : hours;
    minutes = minutes.length === 1 ? ("0" + minutes) : minutes;
    seconds = seconds.length === 1 ? ("0" + seconds) : seconds;
    if (type === "yyyy-MM-dd HH:mm:ss") {
        return date.getFullYear() + seperator1 + month + seperator1 + day + " " + hours + seperator2 + minutes + seperator2 + seconds;
    } else if (type === "yyyy-MM-dd HH:mm") {
        return date.getFullYear() + seperator1 + month + seperator1 + day + " " + hours + seperator2 + minutes;
    } else if (type === "yyyy-MM-dd") {
        return date.getFullYear() + seperator1 + month + seperator1 + day;
    } else if (type === "yyyy-MM") {
        return date.getFullYear() + seperator1 + month;
    } else if (type === "MM") {
        return month;
    } else if (type === "HH:mm") {
        return hours + seperator2 + minutes;
    } else if (type === "MM-dd") {
        return month + seperator1 + day;
    } else if (type === "yyyy/MM/dd") {
        return date.getFullYear() + seperator3 + month + seperator3 + day;
    } else if (type === "yyyy/MM/dd HH:mm:ss") {
        return date.getFullYear() + seperator3 + month + seperator3 + day + " " + hours + seperator2 + minutes + seperator2 + seconds;
    }

}

/**
 * @description 递归查找字符串，并赋值
 * @param arr {array}
 * @param findArr {array}
 * @param obj {object} 要操作的对象
 * @param split {string} 分隔符
 */

function handleFlat(arr, findArr, obj, split = '/') {
    const flat = (arr, findArr, obj, index = 0) => {
        const currentObj = findArr.find(item => arr[index] === item.key)
        if (currentObj) {
            obj.tagsName = `${obj.tagsName ? obj.tagsName + split : ''}${currentObj.value}`
            obj.tagsNameEn = `${obj.tagsNameEn ? obj.tagsNameEn + split : ''}${currentObj.valueEn}`
        }

        if (currentObj && currentObj.category && currentObj.category.length) {
            flat(arr, currentObj.category, obj, ++index)
        }
    }
    flat(arr, findArr, obj)

    return obj
}
/* 秒数转换时分秒 180秒 => 00:03:00 */
function timeFormat(value) {
    var theTime = parseInt(value);// 秒
    var middle= 0;// 分
    var hour= 0;// 小时
    let addZero = (num) => {
        if (!num) return '00'
        return num < 10 ? '0' + num : num
    }

    if(theTime > 60) {
        middle= parseInt(theTime/60);
        theTime = parseInt(theTime%60);
        if(middle> 60) {
            hour= parseInt(middle/60);
            middle= parseInt(middle%60);
        }
    }
    return addZero(parseInt(hour)) + ':' + addZero(parseInt(middle)) + ':' + addZero(parseInt(theTime))
}

export default {
    playersType,
    byage,
    audioPlayUrl,
    randomFn,
    GetQueryString,
    strLength,
    getRandomArrayElements,
    formatDate,
    handleFlat,
    copy,
    timeFormat
}
